import { render, staticRenderFns } from "./recyclingMachineDetail.vue?vue&type=template&id=821b4e3e&scoped=true&"
import script from "./recyclingMachineDetail.vue?vue&type=script&lang=js&"
export * from "./recyclingMachineDetail.vue?vue&type=script&lang=js&"
import style0 from "./recyclingMachineDetail.vue?vue&type=style&index=0&id=821b4e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821b4e3e",
  null
  
)

export default component.exports